/* Compatibility for existing callers. Shopify keeps each browser's active cart.
 * Retired implementation: artifacts/cart-sync-audit-2026-10-21/live-dg-cart-sync.js.
 * No account cart is automatically read, written, cleared or restored.
 */
(function () {
    'use strict';
    function idle() { return Promise.resolve(); }
    window.dgCartSync = { syncToServer: idle, syncFromServer: idle, isSyncEnabled: function () { return false; } };
})();
